import React from "react";
import BranchLink from "web/react/components/branch-link/branch-link";
import { RawBranchLink } from "web/script/utils/branch-io";
import img from "./app-download-teaser-image.jpg";

export function AppDownloadImage(): JSX.Element {
    return (
        <BranchLink
            branchLink={RawBranchLink.AppTeaser}
            eventLabel={"app_page_download_image"}
            title={""}
        >
            <img src={img} alt="App Teaser Image" />
        </BranchLink>
    );
}

export default AppDownloadImage;
